<template>
  <div>
    <img v-if="url" :src="url" alt="coin icon" width="34" height="34">
    <img v-else src="@/assets/logo_group.svg" class="fallback-logo" alt="fallback coin icon" width="34" height="34">
  </div>
</template>

<script>
export default {
  name: 'CoinIcon',
  props: [
    'url',
  ],
};
</script>

<style lang="scss" scoped>
div {
  height: 34px;

  img.fallback-logo {
    filter: grayscale(100%);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/coin/CoinIcon.vue